import React, { useState, useEffect } from 'react';
import './App.css';
import Login from './Login';
import Dashboard from './Dashboard';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [role, setRole] = useState('admin');

  useEffect(() => {
    // Restore a prior session (creds + role) from localStorage.
    const username = localStorage.getItem('admin_username');
    const password = localStorage.getItem('admin_password');
    if (!username || !password) return;
    // Show the cached role immediately, then RE-VALIDATE against the server. The stored
    // role can be stale (e.g. captured before a backend role change), so we re-fetch
    // /admin/whoami on every load and correct it — otherwise a stale role would stick
    // forever since an authenticated session never revisits the login screen.
    setRole(localStorage.getItem('admin_role') || 'admin');
    setIsAuthenticated(true);
    (async () => {
      try {
        const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;
        const res = await fetch(`${apiEndpoint}/admin/whoami`, {
          headers: { 'Authorization': 'Basic ' + btoa(`${username}:${password}`) },
          cache: 'no-store',
        });
        if (res.status === 401 || res.status === 403) { handleLogout(); return; }
        if (!res.ok) return; // transient server issue — keep the cached role for now
        const data = await res.json();
        const freshRole = (data && data.role) || 'admin';
        localStorage.setItem('admin_role', freshRole);
        setRole(freshRole);
      } catch {
        // Network hiccup — leave the cached session as-is.
      }
    })();
  }, []);

  const handleLogin = (loggedInRole) => {
    setRole(loggedInRole || localStorage.getItem('admin_role') || 'admin');
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('admin_username');
    localStorage.removeItem('admin_password');
    localStorage.removeItem('admin_role');
    setIsAuthenticated(false);
  };

  if (!isAuthenticated) {
    return <Login onLogin={handleLogin} />;
  }

  return <Dashboard role={role} onLogout={handleLogout} />;
}

export default App;
